import { useState } from 'react';
import { PopoverProps } from '@mui/material';

interface UseFilterPopoverOptions {
  popoverId?: string;
  anchorOrigin?: PopoverProps['anchorOrigin'];
  minHeight?: string;
}

export const useFilterPopover = (options?: UseFilterPopoverOptions) => {
  const [isOpen, setIsOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const popoverId = isOpen ? (options?.popoverId || 'filter-popover') : undefined;

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const popoverProps: PopoverProps = {
    id: popoverId,
    open: isOpen,
    onClose: handleClose,
    anchorEl,
    anchorOrigin: options?.anchorOrigin || {
      vertical: 'top',
      horizontal: 'left',
    },
    slotProps: {
      paper: {
        sx: { minHeight: options?.minHeight || '100px' },
      },
    },
  };

  return {
    isOpen,
    anchorEl,
    handleOpen,
    handleClose,
    popoverProps,
  };
};

